import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, Button, Box, Typography,
  FormControl, Select, MenuItem, Checkbox, FormControlLabel, TextField
} from '@mui/material';
import PropTypes from 'prop-types';

const planetOptions = [
  'Sun', 'Moon', 'Mercury', 'Venus', 'Mars', 'Jupiter',
  'Uranus', 'Neptune', 'Pluto', 'Rahu'
]; // 'Ketu' removed from dropdowns

const StrategyReportStudyDialog = ({ open, onClose }) => {
  // Block 1
  const [block1Rows, setBlock1Rows] = useState([
    { planet1: 'Sun', planet2: 'Moon', degrees: 30, includeShort: false },
    { planet1: 'Moon', planet2: 'Mars', degrees: 45, includeShort: false }
  ]);
  // Block 2
  const [block2Rows, setBlock2Rows] = useState([
    { planet: 'Moon', degree: '', buy: '', includeShort: false },
    { planet: 'Moon', degree: '', sell: '', includeShort: false }
  ]);
  // Block 3
  const [block3Rows, setBlock3Rows] = useState([
    { planet1: planetOptions[0], planet2: planetOptions[1], midpoint: planetOptions[2], buy: '' },
    { planet1: planetOptions[0], planet2: planetOptions[1], midpoint: planetOptions[2], sell: '' }
  ]);


  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { minWidth: 1200, maxWidth: 1200, borderRadius: 2 } }}>
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: 26, pb: 0 }}>Strategy Report Study A</DialogTitle>
      <DialogContent sx={{ p: 2, pt: 1, background: '#fafafa' }}>
        {/* Block 1 */}
        <Box sx={{ border: '1px solid #ccc', borderRadius: 2, mb: 2, p: 1.5, display: 'grid', gridTemplateColumns: 'repeat(11, auto)', alignItems: 'center', minWidth: 1100 }}>
          <Typography sx={{ minWidth: 60 }}>Planet</Typography>
          <FormControl size="small" sx={{ minWidth: 90 }}>
            <Select value={block1Rows[0].planet1} onChange={e => {
              const arr = [...block1Rows]; arr[0].planet1 = e.target.value; setBlock1Rows(arr);
            }}>{planetOptions.map(p => <MenuItem key={p} value={p} disabled={p === block1Rows[0].planet2}>{p}</MenuItem>)}</Select>
          </FormControl>
          <Typography sx={{ mx: 2 }}>Trailing behind Planet</Typography>
          <FormControl size="small" sx={{ minWidth: 90 }}>
            <Select value={block1Rows[0].planet2} onChange={e => {
              const arr = [...block1Rows]; arr[0].planet2 = e.target.value; setBlock1Rows(arr);
            }}>{planetOptions.map(p => <MenuItem key={p} value={p} disabled={p === block1Rows[0].planet1}>{p}</MenuItem>)}</Select>
          </FormControl>
          <Typography sx={{ mx: 2 }}>By Degrees</Typography>
          <TextField size="small" type="number" value={block1Rows[0].degrees} onChange={e => {
            let val = parseInt(e.target.value, 10);
            if (isNaN(val)) val = '';
            else if (val < 0) val = 0;
            else if (val > 359) val = 359;
            const arr = [...block1Rows]; arr[0].degrees = val; setBlock1Rows(arr); }} sx={{ width: 80 }} inputProps={{ min: 0, max: 359 }} />
          <Typography sx={{ fontWeight: 'bold', minWidth: 32, ml: 2 }}>BUY</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gridColumn: '11/13', gridRow: '1 / span 2', gap: 2 }}>
  <FormControlLabel control={<Checkbox />} label={<Typography sx={{ fontSize: 13, lineHeight: 1.1 }}>Include Short and Cover trade</Typography>} sx={{ m: 0, alignItems: 'center' }} />
  <Button variant="contained" sx={{ width: 100, height: 40, ml: 2 }} disabled>RUN</Button>
</Box>

          {/* Row 2 */}
          <Typography sx={{ minWidth: 60, gridRow: 2 }}>Planet</Typography>
          <FormControl size="small" sx={{ minWidth: 90, gridRow: 2 }}>
            <Select value={block1Rows[1].planet1} onChange={e => {
              const arr = [...block1Rows]; arr[1].planet1 = e.target.value; setBlock1Rows(arr);
            }}>{planetOptions.map(p => <MenuItem key={p} value={p} disabled={p === block1Rows[1].planet2}>{p}</MenuItem>)}</Select>
          </FormControl>
          <Typography sx={{ mx: 2, gridRow: 2 }}>Trailing behind Planet</Typography>
          <FormControl size="small" sx={{ minWidth: 90, gridRow: 2 }}>
            <Select value={block1Rows[1].planet2} onChange={e => {
              const arr = [...block1Rows]; arr[1].planet2 = e.target.value; setBlock1Rows(arr);
            }}>{planetOptions.map(p => <MenuItem key={p} value={p} disabled={p === block1Rows[1].planet1}>{p}</MenuItem>)}</Select>
          </FormControl>
          <Typography sx={{ mx: 2, gridRow: 2 }}>By Degrees</Typography>
          <TextField size="small" type="number" value={block1Rows[1].degrees} onChange={e => {
            let val = parseInt(e.target.value, 10);
            if (isNaN(val)) val = '';
            else if (val < 0) val = 0;
            else if (val > 359) val = 359;
            const arr = [...block1Rows]; arr[1].degrees = val; setBlock1Rows(arr); }} sx={{ width: 80, gridRow: 2 }} inputProps={{ min: 0, max: 359 }} />
          <Typography sx={{ fontWeight: 'bold', minWidth: 32, ml: 2, gridRow: 2 }}>SELL</Typography>
        </Box>

        {/* Block 2 */}
        <Box sx={{ border: '1px solid #ccc', borderRadius: 2, mb: 2, p: 1.5, display: 'grid', gridTemplateColumns: 'repeat(11, auto)', alignItems: 'center', minWidth: 1100 }}>
          <Typography sx={{ minWidth: 60 }}>Planet</Typography>
          <FormControl size="small" sx={{ minWidth: 90 }}>
            <Select value={block2Rows[0].planet} onChange={e => {
              const arr = [...block2Rows]; arr[0].planet = e.target.value; setBlock2Rows(arr);
            }}>{planetOptions.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}</Select>
          </FormControl>
          <Typography sx={{ mx: 2 }}>At a Specific Degree in Sidereal Zodiac</Typography>
          <TextField size="small" sx={{ width: 80 }} value={block2Rows[0].degree} onChange={e => {
            let val = parseInt(e.target.value, 10);
            if (isNaN(val)) val = '';
            else if (val < 0) val = 0;
            else if (val > 359) val = 359;
            const arr = [...block2Rows]; arr[0].degree = val; setBlock2Rows(arr); }} inputProps={{ min: 0, max: 359 }} />
          <Typography sx={{ fontWeight: 'bold', minWidth: 32, ml: 2 }}>BUY</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gridColumn: '11/13', gridRow: '1 / span 2', gap: 2 }}>
  <FormControlLabel control={<Checkbox />} label={<Typography sx={{ fontSize: 13, lineHeight: 1.1 }}>Include Short and Cover trade</Typography>} sx={{ m: 0, alignItems: 'center' }} />
  <Button variant="contained" sx={{ width: 100, height: 40, ml: 2 }} disabled>RUN</Button>
</Box>

          {/* Row 2 */}
          <Typography sx={{ minWidth: 60, gridRow: 2 }}>Planet</Typography>
          <FormControl size="small" sx={{ minWidth: 90, gridRow: 2 }}>
            <Select value={block2Rows[1].planet} onChange={e => {
              const arr = [...block2Rows]; arr[1].planet = e.target.value; setBlock2Rows(arr);
            }}>{planetOptions.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}</Select>
          </FormControl>
          <Typography sx={{ mx: 2, gridRow: 2 }}>At a Specific Degree in Sidereal Zodiac</Typography>
          <TextField size="small" sx={{ width: 80, gridRow: 2 }} value={block2Rows[1].degree} onChange={e => {
            let val = parseInt(e.target.value, 10);
            if (isNaN(val)) val = '';
            else if (val < 0) val = 0;
            else if (val > 359) val = 359;
            const arr = [...block2Rows]; arr[1].degree = val; setBlock2Rows(arr); }} inputProps={{ min: 0, max: 359 }} />
          <Typography sx={{ fontWeight: 'bold', minWidth: 32, ml: 2, gridRow: 2 }}>SELL</Typography>
        </Box>

        {/* Block 3 */}
        <Box sx={{ border: '1px solid #ccc', borderRadius: 2, mb: 2, p: 1.5, display: 'grid', gridTemplateColumns: 'repeat(13, auto)', alignItems: 'center', minWidth: 1100 }}>
          <Typography sx={{ minWidth: 60 }}>Planet</Typography>
          <FormControl size="small" sx={{ minWidth: 90 }}>
            <Select value={block3Rows[0].planet1} onChange={e => {
              const arr = [...block3Rows]; arr[0].planet1 = e.target.value; setBlock3Rows(arr);
            }}>{planetOptions.map(p => <MenuItem key={p} value={p} disabled={p === block3Rows[0].planet2 || p === block3Rows[0].midpoint}>{p}</MenuItem>)}</Select>
          </FormControl>
          <Typography sx={{ mx: 2 }}>Midpoint between planet</Typography>
          <FormControl size="small" sx={{ minWidth: 90 }}>
            <Select value={block3Rows[0].planet2} onChange={e => {
              const arr = [...block3Rows]; arr[0].planet2 = e.target.value; setBlock3Rows(arr);
            }}>{planetOptions.map(p => <MenuItem key={p} value={p} disabled={p === block3Rows[0].planet1 || p === block3Rows[0].midpoint}>{p}</MenuItem>)}</Select>
          </FormControl>
          <Typography sx={{ mx: 2 }}>And</Typography>
          <FormControl size="small" sx={{ minWidth: 90 }}>
            <Select value={block3Rows[0].midpoint} onChange={e => {
              const arr = [...block3Rows]; arr[0].midpoint = e.target.value; setBlock3Rows(arr);
            }}>
              {planetOptions.map(p => <MenuItem key={p} value={p} disabled={p === block3Rows[0].planet1 || p === block3Rows[0].planet2}>{p}</MenuItem>)}
            </Select>
          </FormControl>
          <Typography sx={{ fontWeight: 'bold', minWidth: 32, ml: 2 }}>BUY</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gridColumn: '11/13', gridRow: '1 / span 2', gap: 2 }}>
  <FormControlLabel control={<Checkbox />} label={<Typography sx={{ fontSize: 13, lineHeight: 1.1 }}>Include Short and Cover trade</Typography>} sx={{ m: 0, alignItems: 'center' }} />
  <Button variant="contained" sx={{ width: 100, height: 40, ml: 2 }} disabled>RUN</Button>
</Box>

          {/* Row 2 */}
          <Typography sx={{ minWidth: 60, gridRow: 2 }}>Planet</Typography>
          <FormControl size="small" sx={{ minWidth: 90, gridRow: 2 }}>
            <Select value={block3Rows[1].planet1} onChange={e => {
              const arr = [...block3Rows]; arr[1].planet1 = e.target.value; setBlock3Rows(arr);
            }}>{planetOptions.map(p => <MenuItem key={p} value={p} disabled={p === block3Rows[1].planet2 || p === block3Rows[1].midpoint}>{p}</MenuItem>)}</Select>
          </FormControl>
          <Typography sx={{ mx: 2, gridRow: 2 }}>Midpoint between planet</Typography>
          <FormControl size="small" sx={{ minWidth: 90, gridRow: 2 }}>
            <Select value={block3Rows[1].planet2} onChange={e => {
              const arr = [...block3Rows]; arr[1].planet2 = e.target.value; setBlock3Rows(arr);
            }}>{planetOptions.map(p => <MenuItem key={p} value={p} disabled={p === block3Rows[1].planet1 || p === block3Rows[1].midpoint}>{p}</MenuItem>)}</Select>
          </FormControl>
          <Typography sx={{ mx: 2, gridRow: 2 }}>And</Typography>
          <FormControl size="small" sx={{ minWidth: 90, gridRow: 2 }}>
            <Select value={block3Rows[1].midpoint} onChange={e => {
              const arr = [...block3Rows]; arr[1].midpoint = e.target.value; setBlock3Rows(arr);
            }}>
              {planetOptions.map(p => <MenuItem key={p} value={p} disabled={p === block3Rows[1].planet1 || p === block3Rows[1].planet2}>{p}</MenuItem>)}
            </Select>
          </FormControl>
          <Typography sx={{ fontWeight: 'bold', minWidth: 32, ml: 2, gridRow: 2 }}>SELL</Typography>
        </Box>
        <Box sx={{ gridColumn: '9/12', gridRow: 2, display: 'flex', alignItems: 'flex-end', justifyContent: 'center', mt: 3 }}>
            
          </Box>
        <Box sx={{ gridColumn: '9/12', gridRow: 2, display: 'flex', alignItems: 'flex-end', justifyContent: 'center', mt: 3 }}>
            
          </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
          <Button variant="outlined" color="secondary" onClick={onClose} sx={{ minWidth: 100, height: 40 }}>
            CLOSE
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

StrategyReportStudyDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default StrategyReportStudyDialog;